/*
 *   This file is part of 6502.ts, an emulator for 6502 based systems built
 *   in Typescript
 *
 *   Copyright (c) 2014 -- 2020 Christian Speckner and contributors
 *
 *   Permission is hereby granted, free of charge, to any person obtaining a copy
 *   of this software and associated documentation files (the "Software"), to deal
 *   in the Software without restriction, including without limitation the rights
 *   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 *   copies of the Software, and to permit persons to whom the Software is
 *   furnished to do so, subject to the following conditions:
 *
 *   The above copyright notice and this permission notice shall be included in all
 *   copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 *   SOFTWARE.
 */

import StateMachineInterface from './StateMachineInterface';

class ResultImpl implements StateMachineInterface.Result {
    constructor() {}

    read(nextStep: StateMachineInterface.Step, address: number): this {
        this.cycleType = StateMachineInterface.CycleType.read;
        this.address = address;
        this.nextStep = nextStep;

        return this;
    }

    write(nextStep: StateMachineInterface.Step, address: number, value: number): this {
        this.cycleType = StateMachineInterface.CycleType.write;
        this.address = address;
        this.value = value;
        this.nextStep = nextStep;

        return this;
    }

    poll(poll: boolean): this {
        this.pollInterrupts = poll;

        return this;
    }

    cycleType = StateMachineInterface.CycleType.read;
    address = 0;
    value = 0;
    pollInterrupts = false;
    nextStep: StateMachineInterface.Step = null;
}

export default ResultImpl;
